import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import searchResultsReducer from "./searchResultsReducer";
import downloadLinksReducer from "./downloadLinksReducer";
import searchDefaultValueReducer from "./searchDefaultValueReducer";
import authenticationReducer from "./authenticationReducer";
import readingListReducer from "./readingListReducer";
import bookDetailsReducer from "./bookDetailsReducer";

export default combineReducers({
  form: formReducer,
  searchResults: searchResultsReducer,
  downloadLinks: downloadLinksReducer,
  searchDefaultValue: searchDefaultValueReducer,
  auth: authenticationReducer,
  readingList: readingListReducer,
  bookDetails: bookDetailsReducer,
});
